import { useIntl } from 'react-intl';

import TextInput from 'src/components/TextInput';
import { buildHelperText } from 'src/utils/components';

import messages from './messages';

interface DisabledTextFieldProps {
  helperText?: string;
  field: UCM.DynamicFieldType;
}

export default function DisabledTextField({
  field,
  helperText = '',
}: DisabledTextFieldProps) {
  const { formatMessage } = useIntl();

  return (
    <TextInput
      disabled
      fullWidth
      placeholder={formatMessage(messages.textFieldPlaceholder)}
      helperText={buildHelperText(field?.description, helperText, field?.label)}
    />
  );
}
